"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const getBorderColor_1 = __importDefault(require("./utils/getBorderColor"));
const getInputBorderRadius_1 = __importDefault(require("./utils/getInputBorderRadius"));
const getInputBorderWidth_1 = __importDefault(require("./utils/getInputBorderWidth"));
const getPadding = ({ theme, fixed, iconLeft, iconRight, withPrefix, withSuffix, isReadOnly, }) => {
    if (fixed ||
        (iconLeft && iconRight) ||
        (theme.prefixSuffixInsideInput && withPrefix && withSuffix)) {
        return '0';
    }
    if (iconLeft || (theme.prefixSuffixInsideInput && withPrefix)) {
        return `0 ${theme.horizontalSpacing} 0 0`;
    }
    if (iconRight || (theme.prefixSuffixInsideInput && withSuffix)) {
        return `0 0 0 ${theme.horizontalSpacing}`;
    }
    if (isReadOnly) {
        return `${theme.horizontalSpacingReadOnly}`;
    }
    return `0 ${theme.horizontalSpacing}`;
};
const InputFieldWrapper = styled_components_1.default.div `
  display: flex;
  flex: 1;
  border-width: ${({ theme, withPrefix, withSuffix, focused, isReadOnly }) => (0, getInputBorderWidth_1.default)({
    theme,
    withSuffix,
    withPrefix,
    focused,
    isReadOnly,
})};
  border-style: ${({ theme }) => theme.borderStyle};
  border-color: ${getBorderColor_1.default};
  border-radius: ${({ theme, withSuffix, withPrefix }) => (0, getInputBorderRadius_1.default)({
    theme,
    withSuffix,
    withPrefix,
})};
  box-sizing: border-box;
  margin: ${({ theme, isReadOnly }) => isReadOnly ? `0 0 0 -${theme.borderWidth}` : 0};
  padding: ${getPadding};
  transition: border-color ${({ theme }) => theme.borderTransitionTiming}
    ease-in-out;
  cursor: ${({ isDisabled }) => isDisabled && 'not-allowed'};
`;
InputFieldWrapper.displayName = 'InputFieldWrapper';
exports.default = InputFieldWrapper;
